import { MeetingRoomAvailabilityRequest, MeetingRoomAvailabilityResponse } from '../seatmap/meetingRoomTypes';
import { apiClient } from '../utils/apiClient';

export class MeetingRoomService {
  static async checkAvailability(params: MeetingRoomAvailabilityRequest): Promise<MeetingRoomAvailabilityResponse> {
    const queryParams = new URLSearchParams({
      start_date: params.start_date,
      start_time: params.start_time,
      end_date: params.end_date,
      end_time: params.end_time,
    });

    const endpoint = `/api/meeting-rooms/availability?${queryParams.toString()}`;
    
    try {
      const response = await apiClient.get(endpoint);
      return response?.data || {};
    } catch (error: any) {
      throw new Error(`Failed to check meeting room availability: ${error.message}`);
    }
  }
}